import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-display',
    imports: [],
    templateUrl: './error-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-display.component.scss'
})

export class ErrorDisplayComponent {

	errors: string[] = [];

	constructor(
		public modal: NgbActiveModal 
	){}


	setErrors(errors: string[]) {
		this.errors = errors;
	}

}
